module.exports = __webpack_public_path__ + "img/web6.099e6139.webp";